/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TelemetryAction } from '../interfaces/telemetry-action';
import { SeverityError } from '../enums/severity-error';

export interface TelemetryEvent {
  timestamp?: number;
  dateYMD?: string;
  dateTime?: string;
  source?: string;
  processId?: string;
  organization?: string;
  class?: string;
  userEmail?: string;
  actionData?: TelemetryAction;
  severity?: SeverityError;
  description?: string;
  metadata?: Record<string, any>;
  [key: string]: any; // permite campos extra
}


@Injectable({
  providedIn: 'root'
})
export class TelemetryService {
  private telemetryUrl = environment.TELEMETRY_URL;

  constructor(private http: HttpClient) {
  }

  log(event: TelemetryEvent): void {
        const headers = new HttpHeaders({
                'Content-Type': 'application/json',
                'X-Auth-Token': environment.TELEMETRY_KEY
        });

        const userDistrictRaw = sessionStorage.getItem('UserDistrictSelected');
        const userDistrict = userDistrictRaw ? JSON.parse(userDistrictRaw) : null;
        const userFb = sessionStorage.getItem('user') as any;
        const processId = sessionStorage.getItem('processId');

        const user = userDistrict?.user || (userFb && userFb?.email) || null;
        if(!user){
          return;
        }
    
        const payload: TelemetryEvent = {
                timestamp: Date.now(),
                dateYMD: this.formatDateToYMD(new Date()),
                dateTime: this.formatDateTime(new Date()),
                source: 'student-portal',
                processId : processId ?? 'unknow',
                districtId: userDistrict?.districtId || sessionStorage.getItem('lastDistrict') || null,
                userEmail: user,
                ...event
        };

        this.http.post(this.telemetryUrl, payload, { headers }).subscribe({
            next: () => console.log('Telemetry sent successfully'),
            error: (err) => console.error('Telemetry error:', err)
        });   
    }

    getTelemetryMetadata(): Record<string, any> {
        
        // Construimos los auth dinámicamente
        const authStates: Record<string, boolean> = {
            classlinkAuth: sessionStorage.getItem('classlinkAuth') === 'true',
            cleverAuth: sessionStorage.getItem('cleverAuth') === 'true',
            microsoftAuth: sessionStorage.getItem('microsoftAuth') === 'true',
            googleAuth: sessionStorage.getItem('googleAuth') === 'true'
        };

        // Solo incluimos los que son true
        const authMetadata: Record<string, boolean> = {};
        Object.entries(authStates).forEach(([key, value]) => {
            if (value) authMetadata[key] = true;
        });

        return {      
            // Agregamos solo auths verdaderos
            ...authMetadata,
            browserVersion: navigator.userAgent,
            os: navigator.platform,
            language: navigator.language,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          };
    }

    getOperationName(gqlInstance: any): string | undefined {
        const def = gqlInstance.document.definitions.find(
            (d: any) => d.kind === 'OperationDefinition'
        );
        return def?.name?.value;
   }

  formatDateToYMD(date: Date): string {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 porque los meses van de 0 a 11
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
  }

formatDateTime(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}/${month}/${day}T${hours}:${minutes}:${seconds}`;
}

  generateProcessId(): string {
    const datePart = new Date().toISOString().replace(/[:.-]/g, '');
    const randomPart = Math.random().toString(36).substring(2, 10);
    return `process-${datePart}-${randomPart}`;
  }


}
